import React from 'react';
import './App.css';
import Header from './components/header/Header';
import Hero from './components/hero/Hero';
import Stats from './components/stats/Stats';
import Services from './components/services/Services';
import About from './components/about/About';
import Career from './components/career/Career';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';

function App() {
  return (
    <div className="App">
      <div className="animated-bg"></div>
      <Header />
      <Hero />
      <Stats />
      <Services />
      <About />
      <Career />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
